import { Modal } from '../../shared/ui/modal'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { $keyPrices } from '@/entities/cases'
import { useStyles } from './styles'
import { Icon } from '../../shared/ui/icon'
import { useBuyKeys } from '@/shared/hooks/useBuyKeys'
import { useEffect, useState } from 'react'
type BuyKeysModalWindowProps = {
  isOpen: boolean
  onClose: () => void
  isClickableOutside?: boolean
  isCrossShowed?: boolean
}

export const BuyKeysModalWindow = (props: BuyKeysModalWindowProps) => {
  const { handleBuyKeys, creatingInvoice } = useBuyKeys()
  const userLang = useUnit($userLanguage)
  const keysPriceList = useUnit($keyPrices)
  const { isOpen, isClickableOutside, isCrossShowed = false, onClose } = props
  const [isShow, setIsShow] = useState(false)
  const { classes } = useStyles()
  const btnTexts = lang[userLang].pages.btnTexts

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setIsShow(true)
      }, 1)
    } else {
      setIsShow(false)
    }
  }, [isOpen])
  return (
    <div
      className={classes.root}
      style={{ transform: isShow ? 'translateY(-100%)' : '' }}
    >
      <Modal
        classes={{ title: classes.modalTitle, root: classes.modalRoot }}
        backdropClass={classes.backdrop}
        onClose={onClose}
        isClickableOutside={isClickableOutside}
        isOpen={true}
        crossShowed={isCrossShowed}
        isLoading={creatingInvoice}
        title={
          <div className={classes.modalTitle}>
            <Icon
              view="gamedKey"
              width={52}
            />
            {lang[userLang].pages.main.widgetText.keysAndRewards.needMoreKeys}
          </div>
        }
        content={lang[userLang].pages.main.widgetText.keysAndRewards.buyKeysAndUse}
        btnText={btnTexts.close}
        btnType="secondary"
        contentChildren={
          <>
            <div className={classes.keyListHeader}>
              <div>{lang[userLang].pages.main.widgetText.keysAndRewards.package}</div>
              <div>{lang[userLang].pages.main.widgetText.keysAndRewards.price}</div>
            </div>
            <div className={classes.keyList}>
              {keysPriceList &&
                keysPriceList.map((key, index) => (
                  <div
                    className={classes.keyListItem}
                    key={key.id}
                    onClick={() => handleBuyKeys(key.id)}
                    style={index !== keysPriceList.length - 1 ? { borderBottom: '1px solid #FFFFFF17' } : {}}
                  >
                    <div className={classes.keyListItemContent}>
                      <Icon
                        view="gamedKey"
                        width={18}
                      />
                      {key.amount} {lang[userLang].pages.main.widgetText.keysAndRewards.keys}
                    </div>
                    <div>
                      ⭐ {key.price_stars}{' '}
                      <span className={classes.stars}>
                        {' '}
                        {lang[userLang].pages.main.widgetText.keysAndRewards.stars}
                        <img
                          src="/assets/svg/arrow.svg"
                          alt=""
                          style={{ marginLeft: '8px', opacity: '0.5' }}
                        />
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          </>
        }
      />
    </div>
  )
}
